import { GetServerSideProps, InferGetServerSidePropsType } from 'next'

import { PAGE_PATH } from '@src/quince-site-common/src/constants/pageData'
import SomethingWentWrong from '@src/quince-site-common/src/organisms/somethingWentWrong'
import ReferAndEarn from '@src/quince-site-integrated/src/templates/Auth/ReferAndEarn'
import { ServerSideBaseProps } from '@src/server-side/api/api.types'
import { getServerSideBaseProps } from '@src/server-side/get-server-side-props'

import Layout from '../layout'

export const getServerSideProps = (async ctx => {
  const serverSideBaseProps = await getServerSideBaseProps(ctx, PAGE_PATH.REFER_AND_EARN)
  return serverSideBaseProps
}) satisfies GetServerSideProps<ServerSideBaseProps>

export default function Page(props: InferGetServerSidePropsType<typeof getServerSideProps>) {
  return (
    <Layout {...props}>
      {props.pageData?.authenticationPage ? <ReferAndEarn data={props.pageData} /> : <SomethingWentWrong />}
    </Layout>
  )
}
